import { Component, OnInit } from '@angular/core';
import { OportunidadRealEstate } from 'src/app/home/_models/oportunidad-realestate';
import { ProyectosHomeService } from 'src/app/home/_services/proyectos-home.service';
import { UsuarioService } from 'src/app/_services/usuario.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { FichaHomeComponent } from 'src/app/realestate/shared/home/ficha-home/ficha-home.component';
import { PlatformService } from 'src/app/_services/platform.service';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { SubiendoOportunidadesComponent } from 'src/app/_shared/bloque-loading/subiendo-oportunidades/subiendo-oportunidades.component';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-home-realestate',
  templateUrl: './home-realestate.component.html',
  styleUrls: ['./home-realestate.component.scss'],
  standalone: true,
  imports:[
    SharedModule,
    RouterModule,
    FichaHomeComponent,
    SubiendoOportunidadesComponent
  ]
})

export class HomeRealestateComponent implements OnInit
{
  isLogged: boolean = false;
  platformId: string;
  domainUrl: string;
  proyectoRealEstateId: number;
  isLoading: boolean = false;
  oportunidadRealEstate: OportunidadRealEstate;
  urlLinea: string;

  constructor(
    private _platformService: PlatformService,
    private _proyectosHomeService: ProyectosHomeService,
    private _usuarioService: UsuarioService,
  ) { }

  ngOnInit(): void
  {
    this.platformId = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment];
    this.domainUrl = this._platformService.getSubdominioUrl('realestate');
    this.getSession();
    this.getProyectoRealEstate();
    this.getUrlLinea();
  }

  getSession(): void {
    this.isLogged = this._usuarioService.getSession() ? true : false;
  }

  getProyectoRealEstate()
  {
    this.isLoading = true;
    this._proyectosHomeService.getProyectosHome('realestate').subscribe({
      next: (r) =>
      {
        this.isLoading = false;
        this.proyectoRealEstateId = r.proyectoId;
      },
      complete: () => { 
        this.proyectoRealEstateId > 0 && this.getOportunidadRealEstate() 
      },
      error: () =>
      {
        this.isLoading = false;
      }
    });
  }

  getOportunidadRealEstate()
  {
    this.isLoading = true;
    this._proyectosHomeService.getProyectoRealEstate(this.proyectoRealEstateId).subscribe({
      next: (r) =>
      {
        this.isLoading = false;
        this.oportunidadRealEstate = r;
        if (this.oportunidadRealEstate.galeria == null || this.oportunidadRealEstate.galeria.length == 0)
        {
          this.getGaleriaProyectoRealEstate();
        }
      },
      error: () =>
      {
        this.isLoading = false;
      }
    });
  }

  getGaleriaProyectoRealEstate()
  {
    this.isLoading = true;
    this._proyectosHomeService.getGaleriaRealEstate(this.oportunidadRealEstate.slug).subscribe({
      next: (r) =>
      {
        this.oportunidadRealEstate.galeria = r;
        this.isLoading = false;
      },
      error: () =>
      {
        this.isLoading = false;
        console.error("ERROR: No se ha podido obtener la galeria del proyecto");
      }
    });
  }

  getUrlLinea()
  {
    if (this._usuarioService.getSession())
    {
      this.urlLinea = "/panel-inversor";
    } else
    {
      this.urlLinea = "/oportunidades-inversion";
    }
  }
}
